
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import HubspotIntegrationSettings from '../HubspotIntegrationSettings';
import ZohoCRMIntegrationSettings from '../ZohoCRMIntegrationSettings';
import { HubspotIcon, ZohoIcon } from './IntegrationIcons';

interface CRMIntegrationsProps {
  onSaved: () => Promise<void>;
}

const CRMIntegrations: React.FC<CRMIntegrationsProps> = ({ onSaved }) => {
  const [crmTab, setCrmTab] = useState('hubspot');

  return (
    <Tabs value={crmTab} onValueChange={setCrmTab} className="w-full">
      <TabsList className="mb-4 grid w-full max-w-md grid-cols-2">
        <TabsTrigger value="hubspot" className="flex items-center">
          <HubspotIcon className="mr-2 h-4 w-4" />
          <span>HubSpot</span>
        </TabsTrigger>
        <TabsTrigger value="zoho" className="flex items-center">
          <ZohoIcon className="mr-2 h-4 w-4" />
          <span>Zoho CRM</span>
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="hubspot">
        <HubspotIntegrationSettings onSaved={onSaved} />
      </TabsContent>
      
      <TabsContent value="zoho">
        <ZohoCRMIntegrationSettings onSaved={onSaved} />
      </TabsContent>
    </Tabs>
  );
};

export default CRMIntegrations;
